import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { useAppSelector } from "hooks/store/hooks";
import { selectColorThemeMode } from "stores/uiSlice";

const PageSelector = ({ pageSize, setPageSize, setPageNumber }) => {
  const colorThemeMode = useAppSelector(selectColorThemeMode);
  return (
    <Box display="flex" alignItems="center" w="150px" mr="20px">
      <Text marginBottom={0} mr="10px">
        Rows
      </Text>
      <Menu variant={"dropDown"} isLazy lazyBehavior="unmount">
        <MenuButton
          as={Button}
          w="80px"
          pl={2}
          pr={0}
          color={`${colorThemeMode}_text`}
          bg={`${colorThemeMode}_background`}
        >
          <Box
            alignItems="center"
            display="flex"
            justifyContent="space-between"
            gap="1"
          >
            <Text
              size={{ base: "xs", md: "sm" }}
              variant="black"
              marginBottom={0}
              fontWeight="500"
              overflow="clip"
              whiteSpace="nowrap"
              wordBreak="keep-all"
              textOverflow="ellipsis"
            >
              {pageSize}
            </Text>
            <ChevronDownIcon
              borderLeft="1px solid #e1e1e1"
              color="currentcolor"
              w={"8"}
              h={"6"}
            />
          </Box>
        </MenuButton>
        <MenuList
          w="70px"
          minW="auto"
          borderRadius={"4px"}
          bg={`${colorThemeMode}_background`}
          boxShadow={"1px 1px 15px rgba(0, 0, 0, .1)"}
        >
          {[100, 150, 200, 300, 500].map((option) => (
            <MenuItem
              key={option}
              as={Box}
              zIndex={3}
              h="50px"
              isActive={option === pageSize}
              justifyContent={"flex-start"}
              value={option}
              onClick={() => {
                setPageSize(option);
                setPageNumber(1);
              }}
              bgColor={`${colorThemeMode}_background`}
              color={`${colorThemeMode}_text`}
              borderTop={"1px solid"}
              borderTopColor={`${colorThemeMode}_tertiary`}
              _hover={{
                color: `${colorThemeMode}_primary`,
                bgColor: `${colorThemeMode}_tertiary`,
                cursor: "pointer",
              }}
            >
              {option}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
};
export default PageSelector;
